export default __webpack_public_path__ + "static/recreative-c8ce26eaef98b4419c2adc3f2db69b6d.jpg";